import styled from 'styled-components';
import { Container } from 'react-awesome-styled-grid';
import { media } from '../mediaUtils';

export const TipWrap = styled.div`
  position: relative;
  display: inline;
  margin-left: 8px;
  outline: none;
  pointer-events: none;
  > div {
    outline: none;
    pointer-events: auto;
    :focus {
      outline: 2px solid ${(p) => p.theme.blue};
      border-radius: 3px;
    }
    :hover, :focus, :active {
      svg {
        fill: ${(p) => p.theme.medium_teal};
      }
    }
  }
  > span {
    position: absolute;
    width: 190px;
    color: #FFFFFF;
    background: #142A35;
    border-radius: 3px;
    padding: 10px 15px;
    font-size: ${(p) => p.theme.fontSm};
    top: 30px;
    left: 50%;
    margin-left: -96px;
    z-index: 999;
    pointer-events: auto;
  }
  > span:after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -8px;
    width: 0; height: 0;
    border-bottom: 8px solid #142A35;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
  }
  svg {
    fill: ${(p) => p.theme.dark_gray};
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-bottom: 3px;
  }
`;

export const TextButton = styled.button`
  border: none;
  background-color: inherit;
  color: ${(p) => p.theme.aqua};
  font-family: ${(p) => p.theme.fontFamily};
  font-size: 14px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  &:focus {
    text-decoration: underline;
  }
`;

export const InlineTextButton = styled.button`
  border: none;
  background-color: inherit;
  color: ${(p) => p.theme.aqua};
  font-size: 14px;
  cursor: pointer;
  padding: 0;
`;

export const BlurbText = styled.span`
  width: 100%;
  > div {
    font-size: ${(p) => p.theme.fontSm};
    max-width: 100%;
  }
  > div.linkContainer {
    padding-top: 10px;
  }
`;

export const ExpiredNotice = styled.div`
  background: ${(p) => p.theme.very_light_yellow};
  border: 1px solid ${(p) => p.theme.dark_yellow};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
  padding: 10px 14px;
  box-sizing: border-box;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`;

export const ExpiredContent = styled.div`
  flex-grow: 1.0;
  padding-left: 0.5em;
`;

/* accordian styles for expandable sections */
export const AccordionSection = styled.div`
  .accordion {
    margin: 0;
    padding: 0;
    border: 2px solid hsl(0deg 0% 52%);
    border-radius: 7px;
    width: 20em;
  }
  .accordion h3 {
    margin: 0;
    padding: 0;
    display: fit-content;
  }

  .accordion:focus-within {
    border-color: hsl(216deg 94% 43%);
  }

  .accordion:focus-within h3 {
    background-color: hsl(0deg 0% 97%);
  }

  .accordion > * + * {
    border-top: 1px solid hsl(0deg 0% 52%);
  }

  .accordion-trigger {
    background: none;
    color: hsl(0deg 0% 13%);
    display: block;
    font-size: 1rem;
    font-weight: normal;
    margin: 0;
    padding: 1em 1.5em;
    position: relative;
    text-align: left;
    width: 100%;
    outline: none;
  }

  .accordion-trigger:focus,
  .accordion-trigger:hover {
    background: hsl(216deg 94% 94%);
  }

  .accordion-trigger:focus {
    outline: 4px solid transparent;
  }

  .accordion > *:first-child .accordion-trigger,
  .accordion > *:first-child {
    border-radius: 5px 5px 0 0;
  }

  .accordion > *:last-child .accordion-trigger,
  .accordion > *:last-child {
    border-radius: 0 0 5px 5px;
  }

  button {
    border-style: none;
  }

  .accordion button::-moz-focus-inner {
    border: 0;
  }

  .accordion-title {
    display: flex;
    pointer-events: none;
    border: transparent 2px solid;
    border-radius: 5px;
    outline: none;
    font-family: 'Source Sans Pro', sans-serif;
  }

  .accordion-trigger:focus .accordion-title {
    border-color: hsl(216deg 94% 43%);
  }

  .accordion-icon-container {
    padding-top: 0.25em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 1.5em;
  }

  .accordion-icon {
    border: solid currentcolor;
    border-width: 0 2px 2px 0;
    height: 0.5rem;
    width: 0.5rem;
    pointer-events: none;
    transition: transform 0.5s;
    transform: translateY(-60%) rotate(45deg);
  }

  .accordion-trigger:focus .accordion-icon,
  .accordion-trigger:hover .accordion-icon {
    border-color: hsl(216deg 94% 43%);
  }

  .accordion-icon.expanded {
    transition: transform 0.5s;
    transform: translateY(-50%) rotate(-135deg);
  }

  .accordion-panel {
    margin: 0;
    padding: 1em 1.5em;
  }

  /* For Edge bug https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4806035/ */
  .accordion-panel[hidden] {
    display: none;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  input {
    border: 1px solid hsl(0deg 0% 42%);
    border-radius: 0.3em;
    display: block;
    font-size: inherit;
    padding: 0.3em 0.5em;
  }
`;
